export const KITS_ROUTES = {
  ROOT: "kits",
  SELECT: "select",
  CREATE: "create",
  EDIT: ":kitId/edit",
} as const;

export const MIN_PRODUCTS_PER_KIT = 2;
export const MAX_PRODUCTS_PER_KIT = 5;
export const MAX_IMAGES_PER_KIT = 5;
export const MAX_UNITS_PER_KIT_PRODUCT = 100;
export const MAX_KIT_NAME_LENGTH = 100;
export const DEFAULT_KIT_DISCOUNT_PERCENTAGE = 10;

export const PRIME_MEMBERSHIP_NOT_ACTIVE = "prime.membership_not_active";
